import React from 'react';
// import { Link } from 'react-router-dom'
import { Row, Col, Layout } from 'antd'
import get from 'lodash/get'

import ResetForm from '../../components/ResetForm/ResetForm';
import Footer from '../../components/Footer/Footer';
import classes from './ResetPassword.css';

import isNotAuthenticated from '../../utils/isNotAuthenticated';

const { Content } = Layout;

class ResetPassword extends React.Component {
  render() {
      const token = get(this.props, 'match.params.token');

      return (
          <div style={{ backgroundColor: '#FAFAFA' }}>
              <Layout className={classes.parentContainer}>
                  <Content className={classes.content}>
                      <Row>
                          <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                              <Row type='flex' justify='center'>
                                  <Col className={classes.loginForm}>
                                    <ResetForm token={token} />
                                  </Col>
                              </Row>
                          </Col>
                      </Row>
                  </Content>
                  <Footer noAdminLink />
              </Layout>
          </div>
      );
    }
}

export default isNotAuthenticated(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPassword.js